import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-dropdown',
    template: `
      <div [formGroup]="form">
        <select class="form-select" [id]="field.name" [formControlName]="field.formControlName" >
          <option *ngFor="let opt of field.fieldDataSource" [value]="opt.id">{{opt.value}}</option>
        </select>
      </div> 
    `
})
export class DropDownComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;

    constructor() {

    }
}